// src/pages/PresentationPage.js
import React from 'react';

const PresentationPage = () => {
    // PDF path - served from Django static files on production
    const pdfPath = '/static-be/Dvakota_Pitch_Deck.pdf';

    return (
        <div className="w-screen h-screen bg-gray-900 flex flex-col fixed inset-0" style={{ margin: 0, padding: 0 }}>
            {/* Header section */}
            <div className="w-full bg-gray-800 py-4 border-b border-gray-700 flex-shrink-0">
                <h1 className="text-2xl md:text-3xl font-bold text-white text-center">
                    Dvakota Pitch Deck
                </h1>
            </div>

            {/* PDF viewer section - takes all available space */}
            <div className="flex-1 w-full bg-gray-900 overflow-hidden">
                <object
                    data={pdfPath}
                    type="application/pdf"
                    className="w-full h-full"
                    aria-label="Dvakota Pitch Deck Presentation"
                >
                    {/* Fallback content for browsers that don't support PDF viewing */}
                    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                        <p className="text-white text-lg mb-4">
                            Your browser doesn't support viewing PDFs directly.
                        </p>
                        <a
                            href={pdfPath}
                            download="Dvakota_Pitch_Deck.pdf"
                            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full transition-all transform hover:scale-105 inline-flex items-center gap-2"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                />
                            </svg>
                            Download PDF
                        </a>
                    </div>
                </object>
            </div>

            {/* Download button footer */}
            <div className="w-full bg-gray-800 py-3 border-t border-gray-700 flex-shrink-0">
                <div className="text-center">
                    <a
                        href={pdfPath}
                        download="Dvakota_Pitch_Deck.pdf"
                        className="text-orange-400 hover:text-orange-300 transition-colors inline-flex items-center gap-2"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                        </svg>
                        Download Presentation
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PresentationPage;
